import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { GlobalProgressSpinnerService } from '@shared/services/global-progress-spinner.service';
import { PasswordModule } from 'primeng/password';
import { FluidModule } from 'primeng/fluid';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-login',
  imports: [
    FormsModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    ReactiveFormsModule,
    FluidModule,
    DialogModule,
  ],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  showKeyRiskDialog: boolean = false;
  readonly form: FormGroup;

  private readonly _authService = inject(AuthService);
  private readonly _globalProgressSpinnerService = inject(
    GlobalProgressSpinnerService
  );
  private readonly _router = inject(Router);
  private readonly _formBuilder = inject(FormBuilder);

  get f() {
    return this.form.controls;
  }

  constructor() {
    this._authService.refresh();

    this.form = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  async onSubmit(): Promise<void> {
    if (this.form.invalid) {
      return;
    }

    const email = this.form.value.email;
    const password = this.form.value.password;
    this._globalProgressSpinnerService.showLoader();

    try {
      const session = await this._authService.getCurrentSession();
      if (session) {
        // Logout any existing session
        await this._authService.logout();
      }

      // Create a new session
      await this._authService.login(email, password);
      this._router.navigate(['/home']);
    } catch (error) {
      console.error('Login failed:', error);
    } finally {
      this._globalProgressSpinnerService.hideLoader();
    }
  }
}
